import { IimAutocompleteFilterable } from '@iim-angular/components';

export class PurchasingGroupFilterOption implements IimAutocompleteFilterable<PurchasingGroupFilterOption> {
    public readonly code: string;
    public readonly name: string;
    public readonly active: boolean;

    constructor(code: string, name: string, active = true) {
        this.code = code;
        this.name = name;
        this.active = active;
    }

    public get value(): PurchasingGroupFilterOption {
        return this;
    }

    public get valueDisplay(): string {
        return this.name ? `${this.code} – ${this.name}` : this.code;
    }

    public equals(identifier: string | number | IimAutocompleteFilterable<PurchasingGroupFilterOption>): boolean {
        if (identifier instanceof PurchasingGroupFilterOption) {
            return identifier.code === this.code;
        }
        return String(identifier) === this.code;
    }

    public matches(query: string | IimAutocompleteFilterable<PurchasingGroupFilterOption>): boolean {
        if (typeof query !== 'string') {
            return this.equals(query);
        }
        const normalized = query.toLowerCase();
        return (
            this.code.toLowerCase().includes(normalized) ||
            this.name.toLowerCase().includes(normalized) ||
            this.valueDisplay.toLowerCase().includes(normalized)
        );
    }
}
